import type { InjectionKey } from 'vue';
import type { NormalizedPreconUserProfilesGlobalOptions } from './options';

/**
 * The injection to get the options into the components.
 */
export const preconUserProfilesOptionsInjectionKey = Symbol(
    'freya-user-profiles library options'
) as InjectionKey<Readonly<NormalizedPreconUserProfilesGlobalOptions>>;
